export const MCD_CUSTOMER_IDS = [
  "33bdb49a-ad1d-4f35-8890-875bbb40bd3e",
  "28404c40-93b5-4fc0-afde-e0d37b7bca6d",
];

export const SILVRETTA_CUSTOMER_ID = "c2a4d630-df34-4bb1-a382-9a4c2b474595";

export const TIROLER_ROHRE_CUSTOMER_ID = "6ffae935-9c6f-4032-9a85-2f84088b8fa7";
